import { Spin } from 'antd';
import { ScatterChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

type Data = Array<[number, number]>;

function ScatterWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'scatter', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <ScatterChart points={data ?? []} />;
}

export const scatterWidgetDef: WidgetDefinition = {
  type: 'scatter',
  name: 'Scatter Chart',
  description: 'Distribution of values',
  icon: 'DotChartOutlined',
  category: 'chart',
  defaultTitle: 'Scatter Chart',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: ScatterWidget,
  settingsSchema: { fields: [] },
};
